<template >
  <div id="evalfinish">
    <div class="evalheaderholder">
      <div class="evaliconholder"><i class="fa fa-flag-checkered evalicon"></i></div>
      <div class="evalpadding">
        <h1 class="clearpadmar">{{ translation(14323) }}</h1>
        <h4 class="clearpadmar" v-html="evalformdata.tblEvaluationFormFooterText"></h4>
        <!-- <div v-if="evalformdata != undefined && evalformdata.personevalid !== null">
              <button v-if="getUrlReferrer()" @click.prevent="gotoUrlReferrer()" class="btn btn-primary">{{translation(14324)}}</button>
            </div> -->
      </div>
      <evaldowntrans :duration="800">
        <div class="bckcol-primary evalbottombar"></div>
      </evaldowntrans>
    </div>
  </div>
</template>
<script>
// import { mapGetters, mapActions } from 'vuex'

// import Vuex from 'vuex'
import { ZoomYTransition as evaldowntrans } from 'vue2-transitions'
import { mapGetters } from 'vuex'
import { util } from 'pevueglobal'
export default {
  name: 'evalfinish',
  data: function () {
    return {
      refurl: '',
    }
  },
  methods: {
    getUrlReferrer: util.getUrlReferrer,
    gotoUrlReferrer: util.gotoUrlReferrer,
  },
  components: {
    evaldowntrans,
  },
  computed: {
    ...mapGetters('evalstore', ['evalformdata']),
  },
}
</script>


